<template>
    <div>
        <div class="c-banner c-banner-small n-col-1 n-border-box n-overflow-hidden">
            <NImage class="c-banner-image n-col-1 n-h-1"
                    type="cover"
                    :src="require('@/assets/image/banner.jpg')">
            </NImage>

            <div class="c-banner-text n-col-1 n-p-3">
                <h1 class="n-c-1 c-max-width n-text-center n-m-auto n-mb-1 c-f-1 n-f-1">{{ LAN.welcome }}</h1>
            </div>
        </div>

        <div class="c-max-width n-m-auto n-mt-3 n-plr-2">
            <div class="n-flex n-flex-a-c n-flex-j-sb n-mb-2">
                <div class="n-mr-2 search-container n-flex n-flex-a-c">
                    <a-input-search v-model:value="keyword"
                                    enter-button
                                    allowClear
                                    size="large"
                                    :placeholder="LAN.nui.common.pleaseEnterKeyword"
                                    @search="searchData" />
                </div>

                <a-button type="primary"
                          shape="round"
                          v-if="canBack()"
                          @click="$router.go(-1)">
                    <template #icon>
                        <LeftOutlined />
                    </template>
                    {{ LAN.common.back }}
                </a-button>
            </div>

            <div class="n-flex n-flex-a-c n-flex-w n-flex-j-sb">
                <div class="n-flex n-flex-a-c">
                    <div class="n-flex n-flex-a-c n-ptb-2 n-mr-4">
                        <span class="title-icon n-flex n-flex-a-c n-flex-j-c n-mr-2 n-c-1 n-radius-3">
                            <EditOutlined class="n-flex-s" />
                        </span>
                        <h1 class="n-c-4 n-f-bold n-m-0">{{ LAN.journal.contributor }}{{ forName }}</h1>
                    </div>
                    <span style="padding-top: 1px">{{ LAN.journal.totalI.replace('|T|', this.data?.length ||
                        0) }}</span>
                </div>
            </div>

            <div v-if="loading">
                <ul class="n-ul n-p-0 list n-bg-1 n-mt-2">
                    <li class="n-b-line n-pointer n-p-4"
                        v-for="item in 3"
                        :key="item">
                        <div class="n-skeleton n-skeleton-text n-ptb-4 n-col-3"></div>
                        <div class="n-skeleton n-skeleton-text n-ptb-4 n-mt-3"></div>
                        <div class="n-skeleton n-skeleton-text n-ptb-4 n-mt-3"></div>
                        <div class="n-skeleton n-skeleton-text n-ptb-4 n-mt-3"></div>
                    </li>
                </ul>
            </div>

            <div v-else-if="data?.length > 0"
                 class="n-bg-1 n-mt-2">
                <ul class="n-ul n-p-0 list">
                    <template v-for="item in data"
                              :key="item">
                        <li class="c-hover">
                            <router-link :to="{ name: 'JDetail', params: { cid: item.id } }"
                                class="n-block c-tab-link c-tab-link-event n-b-line n-pointer n-p-2">
                                <p class="n-block n-f-6 n-c-4 n-f-bold c-hover-target n-m-0"
                                    v-html="parseHilight(item.title, keyword)"></p>

                                <span class="n-block n-c-4">{{ parseAuthors(item.authors) }}</span>

                                <div class="n-flex n-flex-a-e n-flex-j-sb">
                                    <span class="n-block n-c-base n-mr-2" v-if="item.startPage && item.endPage">{{
                                        LAN.journal.pages }}
                                        {{ item.startPage }}-{{ item.endPage }}</span>
                                    <span v-else></span>

                                    <span class="n-c-green n-f-bold n-flex-g" v-if="item.isOpenAccess">{{
                                        LAN.journal.openAccess
                                        }}</span>

                                    <div class="n-block n-col-3 n-text-right">
                                        <a-button type="primary">{{ LAN.common.view }}</a-button>
                                    </div>
                                </div>
                            </router-link>
                        </li>
                    </template>
                </ul>

            </div>

            <a-row :gutter="[15, 15]"
                   class="n-col-1"
                   v-else>
                <a-col class="n-bg-1 n-ptb-3"
                       span="24">
                    <a-empty :description="LAN.journal.noContents"></a-empty>
                </a-col>
            </a-row>
        </div>
    </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex';
import { EditOutlined } from '@ant-design/icons-vue';
import NImage from '@/components/nui/NImage/NImage.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import nui from '@/assets/script';

export default {
    name: 'BDetail',
    computed: {
        ...mapState(nui.extendVue.extendState.concat([])),
    },
    data () {
        return nui.extend(true, {}, nui.extendVue.extendData, {
            loading: false,
            data: [],
            cacheData: [],
            keyword: '',
                forName: ''
        })
    },
    methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
        ...mapMutations(nui.extendVue.extendMutations.concat()),

        NMounted () {
                this.forName = decodeURIComponent(this.$route.query.name)
            this.loadData()
        },
        searchData () {
            this.data = this.extend([], this.cacheData.filter(item => {
                return item.title.toLowerCase().indexOf(this.keyword.toLowerCase()) >= 0
            }))
        },
        loadData () {
            this.loading = true;

            this.request(this.API.journalAuthorPanel, {
                requestId: 'journalAuthorPanel',
                params: { name: this.$route.query.name }
            }).then(res => {
                if (res.code == this.REQUEST_SUCCESS_CODE && res.data) {
                    this.data = res.data || [];
                    this.cacheData = res.data || [];
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            })
        },
        parseAuthors (data = []) {
            var res = JSON.parse(JSON.stringify(data.map(item => item.fullName)))

            if (res.length > 1) {
                if (res.length == 2) {
                    return res.join(' and ')
                } else {
                    res[res.length - 1] = 'and ' + res[res.length - 1]
                    return res.join(', ')
                }
            } else {
                return res.join(', ')
            }
        }
    }),
    components: {
        NImage,
        Breadcrumb,
        EditOutlined
    },
    ...nui.extendVue.extendLife
}
</script>
<style lang="scss" scoped>
.thumb {
    width: 227px;
    height: 320px;

    .thumb-image {
        transition: all 0.3s;
    }
}

.title-icon {
    background-color: rgb(255, 226, 186);
    color: rgb(255, 162, 66);
    padding: 5px;
}

.list {
    &>li {
        position: relative;

        i {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            background-image: $linear;
            background-color: transparent;
            opacity: 0;
            transition: all 0.3s;
        }

        &:hover {
            h1,
            p {
                color: $color-base;
            }

            i {
                opacity: 1;
            }
        }
    }
}
</style>